import { createFileRoute } from '@tanstack/react-router'

import { SettlementsPage } from '@/pages/admin/settlements/settlements-page'

export const Route = createFileRoute('/_private/admin/settlements')({
  component: SettlementsPage,
})
